import { get } from './api';

export function fetchMonitoring(subjectName, skipCount) {
    return get('MonitoringSubjects', {subjectName, skipCount})
}
export function fetchMonitoringEvent(id) {
    return get(`MonitoringSubjects/${id}`)
}



// WEBPACK FOOTER //
// ./src/services/api/monitoring.js